import { Button } from '@/Atomic/Molecules/Button'

export const TaskButton = ({
  label,
  onClick,
  isToggled,
}: {
  label: string
  onClick: (label: string) => void
  isToggled: boolean
}) => {
  return (
    <Button
      value={label}
      size="sm"
      variant="outlined"
      className={isToggled ? 'bg-dark bg-opacity-10' : ''}
      aria-pressed={isToggled}
      onClick={(e) => {
        e.preventDefault()
        onClick(label)
      }}
    >
      {label}
    </Button>
  )
}
